<app-sidebar (toggleEmitter)="toggle()"></app-sidebar>

<section>
  <div id="wrapper" [ngClass]="{'active': showSidebar == true}">

    <div id="page-wrapper" style="margin-left: 5px;">
      <div class="row page-titles">
        <div class="col-md-5 align-self-center">
          <h3 class="text-themecolor">Dashboard</h3>
        </div>
        <div class="col-md-7 align-self-center">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a>Home</a></li>
            <li class="breadcrumb-item active">Dashboard</li>
          </ol>
        </div>
      </div>

      <div class="dashboard-container">

        <!-- DASHBOARD CARDS -->
        <div class="row mb-4" *ngIf="counts$ | async as c">
          <div class="col-md-3">
            <div class="card dashboard-card pending">
              <div class="card-body">
                <p class="card-title">Pending Approvals</p>
                <h2>{{ (c.leaveStatus == 'P' && c.pendingApprovals) || '-' }}</h2>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="card dashboard-card ">
              <div class="card-body">
                <p class="card-title">Leave Requests</p>
                <h2>{{ (c.leaveStatus == 'P' && c.leaveRequests) || '-' }}</h2>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="card dashboard-card">
              <div class="card-body">
                <p class="card-title">Attendance</p>
                <h2>{{ (c.leaveStatus == 'P' && c.attendance) || '-' }}</h2>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="card dashboard-card">
              <div class="card-body">
                <p class="card-title">Other Requests</p>
                <h2>{{ (c.leaveStatus == 'P' && c.otherRequests) || '-' }}</h2>
              </div>
            </div>
          </div>
        </div>

        <!-- BOOTSTRAP TABS -->
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'approvals'" (click)="setTab('approvals')">
              📥 Approvals
            </a>
          </li>

          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'team'" (click)="setTab('team')">
              👥 My Team
            </a>
          </li>

          <!-- <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'metrics'" (click)="setTab('metrics')">
              📊 Team Metrics
            </a>
          </li>

          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'work'" (click)="setTab('work')">
              📝 My Work
            </a>
          </li> -->

          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'portal'" (click)="setTab('portal')">
              👤 Employee Portal
            </a>
          </li>
        </ul>


        <div class="border p-3 mt-3">
          <div class="tab-content-wrapper">

            <app-approvals *ngIf="activeTab === 'approvals'" [empDataFromParent]="empData"></app-approvals>

            <app-my-team *ngIf="activeTab === 'team'"></app-my-team>

            <app-team-metrics *ngIf="activeTab === 'metrics'"></app-team-metrics>

            <app-my-work *ngIf="activeTab === 'work'"></app-my-work>

            <app-employee-portal *ngIf="activeTab === 'portal'"></app-employee-portal>

          </div>

        </div>

      </div>


    </div>
  </div>
  <!-- </div> -->
</section>
